/*
Descrição..........: Arquivo ts, que contém as funções necessárias
Autor..............: Pablo Ebbers
Data Criação.......: 01/03/2020
Última Atualização.: 17/03/2020


Funções/Métodos:
-----
async loadProd(id: number) retorno: um registro
Recebe um ID e consultando o service retorna um registro específico
-----
carregarCategorias() retorno: lista de registros
Função que chama o service e retorna todos os registros da tebela em questão
-----
async onSubmit() retorno: nenhum
Função que é acionada ao clicar do botão no formulário de cadastro ou alteração
 e leva os dados até o service para que seja inserido ou alterado no banco de dados
-----
*/

import { Component, OnInit } from '@angular/core';
import { Produto } from 'src/app/model/produto';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from 'src/app/core/toast.service';
import { ProdutoapiService } from 'src/app/dao/api_produto.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalService } from 'src/app/dao/global.service';
import { OpcionalApiService } from 'src/app/dao/api_opcionais.service';
import { SelectItem } from 'primeng/api/selectitem';
import { ApiGruposopcionaisService } from 'src/app/dao/api-gruposopcionais.service';
import { AlertController, ModalController } from '@ionic/angular';
import { UnidadeApiService } from 'src/app/dao/api_unidade.service';
import { CategoriaApiService } from 'src/app/dao/api_categoria.service';
import { ApiCadeadoService } from 'src/app/dao/api-cadeado.service';
import { Unidade } from 'src/app/model/unidade';

@Component({
  selector: 'app-produto-form',
  templateUrl: './produto-form.page.html',
  styleUrls: ['./produto-form.page.scss'],
})
export class ProdutoFormPage implements OnInit {

  title = 'Novo Produto';
  produto: Produto;
  teste;
  fileToUpload: File = null;
  imgPath;
  produtoNovo;


  items: SelectItem[];
  item: string;

  //OPCIONAIS PRINCRIPAIS VARIAVEIS
  selectedCountries1 = [];
  unselectedCountries = [];
  countries: any[];
  opcionais = [];

  //OPCIONAIS COMPLEMENTARES VARIAVEIS
  selectedCountries2 = [];
  unselectedCountries2 = [];
  countries2: any[];
  opcionais2 = [];

  exibicoes = [];

  categorias = [];
  dominio;

  plano;

  displayModal = false;

  dominioDestino: string;

  categoriasDestino = [];

  catDestino;

  comOpcs = false;

  exibirDia0 = false;
  exibirDia1 = false;
  exibirDia2 = false;
  exibirDia3 = false;
  exibirDia4 = false;
  exibirDia5 = false;
  exibirDia6 = false;
  exibirDiaTodos = false;
  novosDiasExibir;
  disableVar = false;


  ativarDia0 = false;
  ativarDia1 = false;
  ativarDia2 = false;
  ativarDia3 = false;
  ativarDia4 = false;
  ativarDia5 = false;
  ativarDia6 = false;
  ativarDiaTodos = false;
  novosDiasativar;
  disableVar2 = false;
  idParam;
  carregando = false;

  unidade: Unidade;
  tags;
  
  tagsSelecionadas = [];
  listaTags;
  idCategoria;
  
  categoriasNomesAux = [];


  // tslint:disable-next-line: max-line-length
  constructor(private apiOpcs: ApiGruposopcionaisService, private cadeadoService: ApiCadeadoService,private apiCategoria: CategoriaApiService, private apiUnidade: UnidadeApiService, public modalController: ModalController, private router: Router, public alertController: AlertController, private gruposOpcionalService: ApiGruposopcionaisService, private opcionalService: OpcionalApiService, private global: GlobalService, private http: HttpClient, private route: ActivatedRoute, private toast: ToastService, private apiproduto: ProdutoapiService) { }

  ngOnInit() {



    this.carregarUnidade();
    this.plano = this.global.plano;
    this.dominio = this.global.dominio;
    this.items = [];
    this.getOpcionais();
    this.getOpcionaisComplementares();
    this.carregarCategorias();
    this.produto = new Produto();
    this.unidade = new Unidade();


    const idParam2 = this.route.snapshot.paramMap.get('idCat');
    if (idParam2) {
      // tslint:disable-next-line: radix
      this.idCategoria = parseInt(idParam2);
      this.produto.categoria.id = this.idCategoria;
      // tslint:disable-next-line: radix
      //this.loadProd(parseInt(idParam2));
   
    }
    


    const idParam = this.route.snapshot.paramMap.get('id');
    if (idParam) {
      this.idParam = idParam;
      this.title = 'Cadastro de Produto';
      // tslint:disable-next-line: radix
      this.loadProd(parseInt(idParam));
    }
    this.loadExibicoes();
  }

  ionViewWillEnter() {
    this.getOpcionais();
    this.carregarCategorias();
  }

  async carregarUnidade(){
  this.unidade = await this.apiUnidade.getAtual();
  if(this.unidade.tags === null || this.unidade.tags === "" || this.unidade.tags === undefined){
    this.listaTags = null;
  }else{
  let tagsAux = JSON.parse(this.unidade.tags);

  this.listaTags = tagsAux.map(c => {
    return ({ name: c.label, value: c.id });
    // tslint:disable-next-line: align
  })
  //console.log(this.listaTags);
}
}


  selecionarTodos() {
    if (this.exibirDiaTodos) {
      this.exibirDia0 = true;
      this.exibirDia1 = true;
      this.exibirDia2 = true;
      this.exibirDia3 = true;
      this.exibirDia4 = true;
      this.exibirDia5 = true;
      this.exibirDia6 = true;
      this.disableVar = true;
    } else {
      this.disableVar = false;
    }
  }


  selecionarTodos2() {
    if (this.ativarDiaTodos) {
      this.ativarDia0 = true;
      this.ativarDia1 = true;
      this.ativarDia2 = true;
      this.ativarDia3 = true;
      this.ativarDia4 = true;
      this.ativarDia5 = true;
      this.ativarDia6 = true;
      this.disableVar2 = true;
    } else {
      this.disableVar2 = false;
    }
  }

  verificaDias() {
    this.novosDiasExibir = "";

    if (this.exibirDia0) {
      this.novosDiasExibir += "0";
    }
    if (this.exibirDia1) {
      this.novosDiasExibir += "1";
    }
    if (this.exibirDia2) {
      this.novosDiasExibir += "2";
    }
    if (this.exibirDia3) {
      this.novosDiasExibir += "3";
    }
    if (this.exibirDia4) {
      this.novosDiasExibir += "4";
    }
    if (this.exibirDia5) {
      this.novosDiasExibir += "5";
    }
    if (this.exibirDia6) {
      this.novosDiasExibir += "6";
    }
    if (this.exibirDiaTodos) {
      this.novosDiasExibir = "0123456";
    }


    this.novosDiasativar = "";

    if (this.ativarDia0) {
      this.novosDiasativar += "0";
    }
    if (this.ativarDia1) {
      this.novosDiasativar += "1";
    }
    if (this.ativarDia2) {
      this.novosDiasativar += "2";
    }
    if (this.ativarDia3) {
      this.novosDiasativar += "3";
    }
    if (this.ativarDia4) {
      this.novosDiasativar += "4";
    }
    if (this.ativarDia5) {
      this.novosDiasativar += "5";
    }
    if (this.ativarDia6) {
      this.novosDiasativar += "6";
    }
    if (this.ativarDiaTodos) {
      this.novosDiasativar = "0123456";
    }

  }



  verificaDiasPush() {
    if (this.produto.exibir_dias.includes("0")) {
      this.exibirDia0 = true;
    }
    if (this.produto.exibir_dias.includes("1")) {
      this.exibirDia1 = true;
    }
    if (this.produto.exibir_dias.includes("2")) {
      this.exibirDia2 = true;
    }
    if (this.produto.exibir_dias.includes("3")) {
      this.exibirDia3 = true;
    }
    if (this.produto.exibir_dias.includes("4")) {
      this.exibirDia4 = true;
    }
    if (this.produto.exibir_dias.includes("5")) {
      this.exibirDia5 = true;
    }
    if (this.produto.exibir_dias.includes("6")) {
      this.exibirDia6 = true;
    }
    if (this.produto.exibir_dias.includes("0123456")) {
      this.exibirDiaTodos = true;
      this.disableVar = true;
    }


    if (this.produto.promocao_dias.includes("0")) {
      this.ativarDia0 = true;
    }
    if (this.produto.promocao_dias.includes("1")) {
      this.ativarDia1 = true;
    }
    if (this.produto.promocao_dias.includes("2")) {
      this.ativarDia2 = true;
    }
    if (this.produto.promocao_dias.includes("3")) {
      this.ativarDia3 = true;
    }
    if (this.produto.promocao_dias.includes("4")) {
      this.ativarDia4 = true;
    }
    if (this.produto.promocao_dias.includes("5")) {
      this.ativarDia5 = true;
    }
    if (this.produto.promocao_dias.includes("6")) {
      this.ativarDia6 = true;
    }
    if (this.produto.promocao_dias.includes("0123456")) {
      this.ativarDiaTodos = true;
      this.disableVar2 = true;
    }
  }

  async loadExibicoes() {

    let exibicoesAux = [
      { name: 'Todas', code: '0' },
      { name: 'Loja Online', code: '1' },
      { name: 'Loja Local', code: '2' }
    ];

    this.exibicoes = exibicoesAux.map(c => {
      return ({ label: c.name, value: c.code });
      // tslint:disable-next-line: align
    })

  }

  async pesquisarDominio() {
    let result = await this.apiUnidade.getByDominio(this.dominioDestino);
    if (result) {
      let cats = await this.apiCategoria.listarTodasPorDominio(this.dominioDestino);
      this.categoriasDestino = cats;
      this.toast.showSucess('Categorias Obtidas com Sucesso');
    } else {
      this.toast.showError('Ocorreu um erro ao tentar obter as categorias (dominio inválido ou desativado)');
    }



  }



  async enviarCopia() {
    try {
      let resultado = await this.apiproduto.copiarProdLoja(this.produto, this.dominioDestino, this.catDestino, this.comOpcs);
      this.toast.showSucess('Produto copiado com sucesso!');
    } catch (error) {
      this.toast.showError('Ocorreu um erro ao tentar copiar o Produto');
      console.log(error);
    }

    this.dominioDestino = "";
    this.catDestino = "";
    this.comOpcs = false;
    this.displayModal = false;

  }


  async openModal() {
    this.displayModal = true;
  }



  async confirmarExclusao(codigo) {
    const alert = await this.alertController.create({
      header: 'Confirmar?',
      message: 'Tem certeza de que deseja exlcuir o Produto?',
      buttons: [
        {
          text: 'Não',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
          }
        }, {
          text: 'Sim',
          handler: () => {
            this.excluirProd(codigo)
          }
        }
      ]
    });

    await alert.present();
  }


  verVar(){
    console.log(this.tagsSelecionadas);
  }


  excluirProd(codigo) {
    this.apiproduto.excluir(codigo);
    this.router.navigate(['/categoria-selecao-form']);
  }

  voltarFunc() {
    if (this.produto.categoria.id > 0) {
      this.router.navigate(['/produto-list2', this.produto.categoria.id]);
    } else {
      window.history.go(-1);
    }
  }


  async confirmarDuplicar(produto) {
    const alert = await this.alertController.create({
      header: 'Duplicar Produto',
      message: 'Tem certeza de que deseja duplicar este Produto?',
      buttons: [
        {
          text: 'Não',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
          }
        }, {
          text: 'Sim',
          handler: () => {
            this.duplicarProd(produto)
          }
        }
      ]
    });

    await alert.present();
  }


  async duplicarProd(produto) {
    this.carregando = true;
    this.verificaDias();
    this.produto.exibir_dias = this.novosDiasExibir;
    this.produto.promocao_dias = this.novosDiasativar;
    this.produto = await this.apiproduto.duplicar(produto);

    //VALIDAÇÃO DOS OPCIONAIS COMPLEMENTARES
    // tslint:disable-next-line: prefer-for-of
    for (let index = 0; index < this.selectedCountries2.length; index++) {
      const element = this.selectedCountries2[index];
      const result1 = await this.gruposOpcionalService.insertLigacaco2(this.produto.id, element.code);
    }
    if (this.unselectedCountries2.length !== this.selectedCountries2.length) {
      let indexRemover = -1;
      // tslint:disable-next-line: prefer-for-of
      for (let index = 0; index < this.selectedCountries2.length; index++) {
        const element = this.selectedCountries2[index];


        indexRemover = -1;

        // tslint:disable-next-line: prefer-for-of
        for (let index2 = 0; index2 < this.unselectedCountries2.length; index2++) {
          const element2 = this.unselectedCountries2[index2];


          if (element.code === element2.code) {
            indexRemover = index2;

            break;
          }
        }

        if (indexRemover > -1) {
          // Remover o indexRemover (slice em this.unselectedCountries)
          this.unselectedCountries2.splice(indexRemover, 1);

        }

      }


      // fazer o for na sombra para deletar
      // tslint:disable-next-line: prefer-for-of
      for (let index3 = 0; index3 < this.unselectedCountries2.length; index3++) {
        const element3 = this.unselectedCountries2[index3];

        const result3 = this.gruposOpcionalService.excluirLigacao(element3.code, this.produto.id);


      }

      this.unselectedCountries2 = this.selectedCountries2;

    }
    //VALIDAÇÃO DOS OPCIONAIS COMPLEMENTARES
    this.carregando = false;
    if (this.produto.id > 0) {
      this.router.navigate(['/produto-editar/', this.produto.id]);
    }
  }


  async loadProd(id: number) {
    this.produto = await this.apiproduto.getById(id);


    this.unidade = await this.apiUnidade.getAtual();
    if(this.unidade.tags === null || this.unidade.tags === "" || this.unidade.tags === undefined){
      this.listaTags = null;
    }else{
    let tagsAux = JSON.parse(this.unidade.tags);
    this.listaTags = await tagsAux.map(c => {
      return ({ name: c.label, value: c.id });
      // tslint:disable-next-line: align
    })
    }
    //console.log(this.produto.tags);
    if(this.produto.tags === null || this.produto.tags === "" || this.listaTags === null){

    }else{
      this.tagsSelecionadas = [];
      let tagsRetornoProd = JSON.parse(this.produto.tags)
      tagsRetornoProd = tagsRetornoProd.filter(element => {
        return element !== null;
      });
      let tagsRetornoProdaux = [];
      let tagsRetornoProdaux3 = [];
      for (let index = 0; index < tagsRetornoProd.length; index++) {
        const element = tagsRetornoProd[index];
        if(element === 1){
          tagsRetornoProdaux3[index] = this.listaTags[0];
        }
        if(element === 2){
          tagsRetornoProdaux3[index] = this.listaTags[1];
        }
        if(element === 3){
          tagsRetornoProdaux3[index] = this.listaTags[2];
        }
        if(element === 4){
          tagsRetornoProdaux3[index] = this.listaTags[3];
        }
      }

      tagsRetornoProdaux = tagsRetornoProdaux3.filter(element => {
        return element !== null;
      });

     tagsRetornoProdaux.map(c => {
        if(c != null && c != undefined && c != ""){
        return ({ name: c.label, value: c.id });
        }
      })
      for (let index = 0; index < tagsRetornoProdaux.length; index++) {
        const element = tagsRetornoProdaux[index];
        if(element != null && element != undefined){
          this.tagsSelecionadas.push(element);
        }
      }
    }
    


    //RETORNO OPCIONAIS PRINCIPAIS
    const opcAux = this.produto.opcionais.map(c => {
      // tslint:disable-next-line: no-string-literal
      return ({ nome: c['nome'] + '  R$' + parseFloat(c['valor']).toFixed(2).replace('.', ','), code: c['id'] });
    });
    this.selectedCountries1 = opcAux;


    this.unselectedCountries = this.selectedCountries1;
    //RETORNO OPCIONAIS PRINCIPAIS


    //RETORNO OPCIONAIS COMPLEMENTARES

    
    

    this.categoriasNomesAux =  await this.apiOpcs.listarTodosNomes()
    .catch(err => {
      console.error('Erro ao obter Opcionais', err);
      this.toast.showError('Erro ao obter Opcionais');
    });


    const opcAux2 = this.produto.opcionais2.map(c => {
      const encontrada = this.categoriasNomesAux.find(g => g.grupo === c['grupo']);
      const nomeGrupo = encontrada ? encontrada.nome : c['grupo'];
      return ({
        nome: `Grupo: ${nomeGrupo} Opcional: ${c['nome']} R$${parseFloat(c['valor']).toFixed(2).replace('.', ',')}`,
        code: c['id']
      });
    });

    this.selectedCountries2 = opcAux2;

    this.unselectedCountries2 = this.selectedCountries2;
    //RETORNO OPCIONAIS COMPLEMENTARES

    this.verificaDiasPush();
  }


  limpaImg() {
    this.produto.img = '';
    let headers = new HttpHeaders();
    const auth = btoa(this.global.user + ':' + this.global.pass);
    headers = headers.set('Authorization', 'Basic ' + auth);
    const body = JSON.stringify(this.produto);
    // tslint:disable-next-line: max-line-length
    this.http.post(this.dominio + '/backend/api/v2/produto/limpaImg', body, { headers }).subscribe((val) => {
    });
    return false;
  }


  postMethod(files: FileList) {
    this.fileToUpload = files.item(0);
    // tslint:disable-next-line: prefer-const
    let formData = new FormData();
    formData.append('file', this.fileToUpload, this.fileToUpload.name);
    let headers = new HttpHeaders();
    const auth = btoa(this.global.user + ':' + this.global.pass);
    headers = headers.set('Authorization', 'Basic ' + auth);
    // tslint:disable-next-line: max-line-length
    this.http.post(this.dominio + '/backend/api/v2/produto/getImg', formData, { headers }).subscribe((val) => {
      this.imgPath = val;
      this.produto.img = this.imgPath;
    });
    return false;
  }

   fecharCadeado(id){
     let result = this.cadeadoService.fecharTrava(id);
     console.log(result);
  }

   diff(a1, a2) {
    return a1.concat(a2).filter(function(val, index, arr){
      return arr.indexOf(val) === arr.lastIndexOf(val);
    });
  }

  async onSubmit() {
    if (this.produto.id) {
      this.produtoNovo = false;
    } else {
      this.produtoNovo = true;
    }
    this.carregando = true;
    
    if(this.produto.tags === null || this.produto.tags === "" || this.listaTags === null){
    }else{
    let tagsSelecionadasAux2 = [];
    let tagsAux = JSON.parse(this.unidade.tags);

    for (let index = 0; index < this.tagsSelecionadas.length; index++) {
      const element = this.tagsSelecionadas[index];
      if (element.value === 1) {
        tagsSelecionadasAux2[0] = tagsAux[0]['id'];
      }
      if (element.value === 2) {
        tagsSelecionadasAux2[1] = tagsAux[1]['id'];
      }
      if (element.value === 3) {
        tagsSelecionadasAux2[2] = tagsAux[2]['id'];
      }
      if (element.value === 4) {
        tagsSelecionadasAux2[3] = tagsAux[3]['id'];
      }
  }
  tagsSelecionadasAux2 = tagsSelecionadasAux2.filter(element => {
    return element !== null;
  });
  this.produto.tags = JSON.stringify(tagsSelecionadasAux2);
}
    

    //let cadeado = await this.cadeadoService.verificarTrava("salvar_produto");
    //console.log(cadeado);
    //if(cadeado.status === "fechado"){
      //this.toast.showError('Aguarde a requisição anterior ser concluída para realizar uma nova!');
      //return;
    //}

    //if(cadeado.status === "aberto"){
      //cadeado = await this.cadeadoService.fecharTrava("salvar_produto");
    //}


     //cadeado = await this.cadeadoService.verificarTrava("salvar_produto");
     //console.log(cadeado);

    this.verificaDias();
    this.produto.exibir_dias = this.novosDiasExibir;
    this.produto.promocao_dias = this.novosDiasativar;
    try {
      console.log(this.produto);
      const result2 = await this.apiproduto.save(this.produto);
      this.produto.id = result2.id;

      //VALIDAÇÃO DOS OPCIONAIS PRINCIPAIS
      // tslint:disable-next-line: prefer-for-of

       for (let index = 0; index < this.selectedCountries1.length; index++) {
        const element = this.selectedCountries1[index];
        const result1 = await this.opcionalService.insertLigacaco2(this.produto.id, element.code);
      }
      //if (this.unselectedCountries.length !== this.selectedCountries1.length) {
        console.log(this.diff(this.selectedCountries1, this.unselectedCountries));
        if (this.diff(this.selectedCountries1, this.unselectedCountries).length > 0) {

          let indexRemover = -1;
          // tslint:disable-next-line: prefer-for-of
          for (let index = 0; index < this.selectedCountries1.length; index++) {
            const element = this.selectedCountries1[index];

            indexRemover = -1;
            // tslint:disable-next-line: prefer-for-of
            for (let index2 = 0; index2 < this.unselectedCountries.length; index2++) {
              const element2 = this.unselectedCountries[index2];

              if (element.code === element2.code) {
                indexRemover = index2;
                break;
              }
            }

            if (indexRemover > -1) {
              // Remover o indexRemover (slice em this.unselectedCountries)
              this.unselectedCountries.splice(indexRemover, 1);

            }

          }

          // fazer o for na sombra para deletar
          // tslint:disable-next-line: prefer-for-of
          for (let index3 = 0; index3 < this.unselectedCountries.length; index3++) {
            const element3 = this.unselectedCountries[index3];
            const result3 = this.opcionalService.excluirLigacao(element3.code, this.produto.id);

          }

          
        //}
      }
      this.unselectedCountries = this.selectedCountries1;
      //VALIDAÇÃO DOS OPCIONAIS PRINCIPAIS


      //VALIDAÇÃO DOS OPCIONAIS COMPLEMENTARES
      // tslint:disable-next-line: prefer-for-of
      for (let index = 0; index < this.selectedCountries2.length; index++) {
        const element = this.selectedCountries2[index];
        const result1 = await this.gruposOpcionalService.insertLigacaco2(this.produto.id, element.code);
      }
      console.log(this.diff(this.selectedCountries2, this.unselectedCountries2));
      if (this.diff(this.selectedCountries2, this.unselectedCountries2).length > 0) {
      //if (this.unselectedCountries2.length !== this.selectedCountries2.length) {
        let indexRemover = -1;
        // tslint:disable-next-line: prefer-for-of
        for (let index = 0; index < this.selectedCountries2.length; index++) {
          const element = this.selectedCountries2[index];

          indexRemover = -1;
          // tslint:disable-next-line: prefer-for-of
          for (let index2 = 0; index2 < this.unselectedCountries2.length; index2++) {
            const element2 = this.unselectedCountries2[index2];

            if (element.code === element2.code) {
              indexRemover = index2;
              break;
            }
          }

          if (indexRemover > -1) {
            // Remover o indexRemover (slice em this.unselectedCountries)
            this.unselectedCountries2.splice(indexRemover, 1);
          }

        }


        // fazer o for na sombra para deletar
        // tslint:disable-next-line: prefer-for-of
        for (let index3 = 0; index3 < this.unselectedCountries2.length; index3++) {
          const element3 = this.unselectedCountries2[index3];
          const result3 = this.gruposOpcionalService.excluirLigacao(element3.code, this.produto.id);

        }

        this.unselectedCountries2 = this.selectedCountries2;

      }
      
      //VALIDAÇÃO DOS OPCIONAIS COMPLEMENTARES
      this.carregando = false;
      this.toast.showSucess('Produto salvo com sucesso');
      this.verificaDiasPush();
      if (this.idParam) {
        this.loadProd(parseInt(this.idParam));
      }
      if (this.produtoNovo) {
        this.router.navigate(['/produto-editar/', this.produto.id]);
      }
    } catch (error) {
      this.carregando = false;
      this.toast.showError('Ocorreu um erro ao tentar salvar o Produto');
      console.log(error);
    }

  
  }


  carregarCategorias() {
    return this.apiproduto.listarAllCategorias()
      .then(categorias => {
        this.categorias = categorias.map(c => {
          return ({ label: c.nome, value: c.id });
          // tslint:disable-next-line: align
        });
      })
      .catch(erro => {
        this.toast.showError('Erro ao carregar Categorias!');
      });
  }



  getOpcionais() {
    return this.opcionalService.listarTodas()
      .then(opcionais => {
        this.countries = opcionais.map(c => {
          return ({ nome: c.nome + '  R$' + parseFloat(c.valor).toFixed(2).replace('.', ','), code: c.id });
          // tslint:disable-next-line: align
        });
      })
      .catch(erro => {
        this.toast.showError('Erro ao carregar Opcionais!');
      });
  }


  getOpcionaisComplementares() {
    return this.gruposOpcionalService.listarTodas()
      .then(async opcionais2 => {

        this.categoriasNomesAux =  await this.apiOpcs.listarTodosNomes()
        .catch(err => {
          console.error('Erro ao obter Opcionais', err);
          this.toast.showError('Erro ao obter Opcionais');
        });
        
      

          opcionais2 = opcionais2.map(item => {
            console.log(item);
            const encontrada = this.categoriasNomesAux.find(g => g.grupo === item.grupo);
            return {
              ...item,
              nomeGrupo: encontrada ? encontrada.nome : item.grupo
            };
          });


          
        this.countries2 = opcionais2.map(c => {
          return ({ nome: 'Grupo: ' + c.nomeGrupo + ' Opcional: ' + c.nome + ' R$' + parseFloat(c.valor).toFixed(2).replace('.', ','), code: c.id });
          // tslint:disable-next-line: align
        });
        

        
      })
      
      .catch(erro => {
        this.toast.showError('Erro ao carregar Opcionais!');
      });
  }




}
